<template>
  <div class="baozhijieshao-list">
    <div class="baozhijieshao-list-title">
      <svg
        t="1688968353051"
        class="icon"
        viewBox="0 0 1024 1024"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        p-id="6419"
        width="28"
        height="28"
      >
        <path
          d="M930 182.444c0-39.984-32.46-72.444-72.444-72.444H238.444c-39.984 0-72.444 32.46-72.444 72.444v659.112c0 39.984 32.46 72.444 72.444 72.444h619.112c39.984 0 72.444-32.46 72.444-72.444V182.444z"
          fill="#ABADCD"
          p-id="6420"
        ></path>
        <path
          d="M825.556 173.4c0-12-3.404-63.108 24.596-63.4H229.4c-34.992 0-63.4 28.408-63.4 63.4v541.828c0 34.992 28.408 63.4 63.4 63.4h532.752c34.992 0 63.404-28.408 63.404-63.4V173.4z"
          fill="#D5D5E3"
          p-id="6421"
        ></path>
        <path
          d="M786 255.032c0-38.1-30.932-69.032-69.032-69.032H163.032c-38.1 0-69.032 30.932-69.032 69.032v589.936c0 38.1 30.932 69.032 69.032 69.032h687.12c-38.1 0-64.152-30.932-64.152-69.032V255.032z"
          fill="#F2F2F7"
          p-id="6422"
        ></path>
        <path
          d="M710 298.58c0-26.812-21.768-48.58-48.58-48.58H194.58c-26.812 0-48.58 21.768-48.58 48.58v97.156c0 26.812 21.768 48.58 48.58 48.58h466.84c26.812 0 48.58-21.768 48.58-48.58V298.58z"
          fill="#00AEFF"
          p-id="6423"
        ></path>
        <path
          d="M710 663.14a28.1 28.1 0 0 0-28.088-28.084h-155.824a28.1 28.1 0 0 0-28.088 28.084v138.144a28.1 28.1 0 0 0 28.088 28.088h155.824a28.1 28.1 0 0 0 28.088-28.088v-138.144z"
          fill="#8FB1F3"
          p-id="6424"
        ></path>
        <path
          d="M710 515.5a11.504 11.504 0 0 0-11.5-11.5H157.5a11.504 11.504 0 0 0-11.5 11.5v23a11.504 11.504 0 0 0 11.5 11.5h541a11.504 11.504 0 0 0 11.5-11.5v-23zM428 638.5c0-3.588-2.912-6.5-6.5-6.5h-269c-3.588 0-6.5 2.912-6.5 6.5v13c0 3.588 2.912 6.5 6.5 6.5h269c3.588 0 6.5-2.912 6.5-6.5v-13zM428 724.184c0-3.588-2.912-6.5-6.5-6.5h-269c-3.588 0-6.5 2.912-6.5 6.5v13c0 3.588 2.912 6.5 6.5 6.5h269c3.588 0 6.5-2.912 6.5-6.5v-13zM320 809.872c0-3.588-2.912-6.5-6.5-6.5h-161c-3.588 0-6.5 2.912-6.5 6.5v13c0 3.584 2.912 6.5 6.5 6.5h161c3.588 0 6.5-2.916 6.5-6.5v-13z"
          fill="#85A1CA"
          p-id="6425"
        ></path></svg
      >{{ lmjsdata.nptitle }}
    </div>
    <div class="baozhijieshao-list-fm" @click="tiaozhuanqikan">
      <el-image
        style="width: 298px; height: 448px"
        :src="`${proxy.$imgurl}${lmjsdata.fm}`"
      ></el-image>
    </div>
    <div class="baozhijieshao-list-xq">
      <el-tabs v-model="activeName" class="demo-tabs">
        <el-tab-pane label="本刊介绍" :name="'jieshao'">
          <div class="baozhijieshao-list-xq-js">
            <div
              class="baozhijieshao-list-xq-js-list baozhijieshao-list-xq-js-list-tsys"
            >
              <div class="baozhijieshao-list-xq-js-list-title">本刊简介：</div>
              <div
                class="baozhijieshao-list-xq-js-list-con baozhijieshao-list-xq-js-list-con-tsys"
              >
                {{ lmjsdata.jianjie }}
              </div>
            </div>
            <div v-if="lmjsdata.zgorg!=''&&lmjsdata.zgorg!=null"
              class="baozhijieshao-list-xq-js-list baozhijieshao-list-xq-js-list-50"
            >
              <div class="baozhijieshao-list-xq-js-list-title">主管单位：</div>
              <div class="baozhijieshao-list-xq-js-list-con">
                {{ lmjsdata.zgorg }}
              </div>
            </div>
            <div v-if="lmjsdata.zborg!=''&&lmjsdata.zborg!=null"
              class="baozhijieshao-list-xq-js-list baozhijieshao-list-xq-js-list-50"
            >
              <div class="baozhijieshao-list-xq-js-list-title">主办单位：</div>
              <div class="baozhijieshao-list-xq-js-list-con">
                {{ lmjsdata.zborg }}
              </div>
            </div>
            <div v-if="lmjsdata.cborg!=''&&lmjsdata.cborg!=null"
              class="baozhijieshao-list-xq-js-list baozhijieshao-list-xq-js-list-50"
            >
              <div class="baozhijieshao-list-xq-js-list-title">出版单位：</div>
              <div class="baozhijieshao-list-xq-js-list-con">
                {{ lmjsdata.cborg }}
              </div>
            </div>
            <!-- <div
              class="baozhijieshao-list-xq-js-list baozhijieshao-list-xq-js-list-50"
            >
              <div class="baozhijieshao-list-xq-js-list-title">协办单位：</div>
              <div class="baozhijieshao-list-xq-js-list-con">
                {{ lmjsdata.xborg }}
              </div>
            </div> -->
            <div v-if="lmjsdata.tgorg!=''&&lmjsdata.tgorg!=null"
              class="baozhijieshao-list-xq-js-list baozhijieshao-list-xq-js-list-50"
            >
              <div class="baozhijieshao-list-xq-js-list-title">推广合作单位：</div>
              <div class="baozhijieshao-list-xq-js-list-con">
                {{ lmjsdata.tgorg }}
              </div>
            </div>
            <div v-if="lmjsdata.yfcode!=''&&lmjsdata.yfcode!=null"
              class="baozhijieshao-list-xq-js-list baozhijieshao-list-xq-js-list-50"
            >
              <div class="baozhijieshao-list-xq-js-list-title">邮发代号：</div>
              <div class="baozhijieshao-list-xq-js-list-con">
                {{ lmjsdata.yfcode }}
              </div>
            </div>
            <div v-if="lmjsdata.gntylxcode!=''&&lmjsdata.gntylxcode!=null"
              class="baozhijieshao-list-xq-js-list baozhijieshao-list-xq-js-list-50"
            >
              <div class="baozhijieshao-list-xq-js-list-title">出版物号：</div>
              <div class="baozhijieshao-list-xq-js-list-con">
                {{ lmjsdata.gntylxcode }}
              </div>
            </div>
            <div v-if="lmjsdata.issn!=''&&lmjsdata.issn!=null"
              class="baozhijieshao-list-xq-js-list baozhijieshao-list-xq-js-list-50"
            >
              <div class="baozhijieshao-list-xq-js-list-title">国际标准刊号：</div>
              <div class="baozhijieshao-list-xq-js-list-con">
                {{ lmjsdata.issn }}
              </div>
            </div>
            <div v-if="lmjsdata.email!=''&&lmjsdata.email!=null"
              class="baozhijieshao-list-xq-js-list baozhijieshao-list-xq-js-list-50"
            >
              <div class="baozhijieshao-list-xq-js-list-title">电子邮箱：</div>
              <div class="baozhijieshao-list-xq-js-list-con">
                {{ lmjsdata.email }}
              </div>
            </div>
            <div v-if="lmjsdata.djprice!=''&&lmjsdata.djprice!=null"
              class="baozhijieshao-list-xq-js-list baozhijieshao-list-xq-js-list-50"
            >
              <div class="baozhijieshao-list-xq-js-list-title">定价：</div>
              <div class="baozhijieshao-list-xq-js-list-con">
                {{ lmjsdata.djprice+"元" }}
              </div>
            </div>
            <!-- <div
              class="baozhijieshao-list-xq-js-list baozhijieshao-list-xq-js-list-50"
            >
              <div class="baozhijieshao-list-xq-js-list-title">
                广告经营许可证号：
              </div>
              <div class="baozhijieshao-list-xq-js-list-con">
                {{ lmjsdata.ggjyxkz }}
              </div>
            </div>
            <div
              class="baozhijieshao-list-xq-js-list baozhijieshao-list-xq-js-list-50"
            >
              <div class="baozhijieshao-list-xq-js-list-title">
                编辑部电话：
              </div>
              <div class="baozhijieshao-list-xq-js-list-con">
                {{ lmjsdata.bjbtel }}
              </div>
            </div>
            <div
              class="baozhijieshao-list-xq-js-list baozhijieshao-list-xq-js-list-50"
            >
              <div class="baozhijieshao-list-xq-js-list-title">印刷单位：</div>
              <div class="baozhijieshao-list-xq-js-list-con">
                {{ lmjsdata.ysorg }}
              </div>
            </div> -->
          </div>
        </el-tab-pane>
        <el-tab-pane label="本刊成果" :name="'chengguo'">
          <div class="baozhijieshao-cg">
            <div class="baozhijieshao-cg-qs">
              <div class="baozhijieshao-cg-qs-title">选择期数</div>
              <div class="baozhijieshao-cg-qs-select">
                <el-cascader
                  filterable
                  placeholder="请选择期数"
                  size="small"
                  v-model="qsvalue"
                  :options="qsoptions"
                  @change="handleChange"
                />
              </div>
            </div>
            <div class="baozhijieshao-cg-ul">
              <div class="baozhijieshao-cg-ul-title">最新成果</div>
              <div class="baozhijieshao-cg-list-null" v-if="newwzlist.length===0">当前期刊暂未发布文章</div>
              <div
                class="baozhijieshao-cg-list"
                v-for="(item, key) in newwzlist"
                :key="key"
                @click="tiaozhuanwz(item.Id)"
              >
                <div class="baozhijieshao-cg-list-name">
                  {{ item.title }}
                </div>
                <div class="baozhijieshao-cg-list-writer">
                  {{ item.writer }}
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script setup>
import { get } from "@/utils/index";
import { ElMessage } from "element-plus";
import { ref, reactive, defineProps, getCurrentInstance } from "vue";
const { proxy } = getCurrentInstance();
// router
import { useRouter } from "vue-router";
const router = useRouter();
// vuex
import { useStore } from "vuex";
const store = useStore();
// 父组件传递值
const props = defineProps({
  lmjsdata: {
    type: Object,
  },
});
// 根据栏目生成需要跳转的路径前缀
let urlqz = ref("");
switch (props.lmjsdata.bztype) {
  case 1:
    urlqz.value = "/jyyj";
    break;
  case 2:
    urlqz.value = "/kjts";
    break;
  case 3:
    urlqz.value = "/jkkp";
    break;
  case 4:
    urlqz.value = "/szyt";
    break;
  case 5:
    urlqz.value = "/myrh";
    break;
  case 6:
    urlqz.value = "/xljj";
    break;
  case 7:
    urlqz.value = "/xxfz";
    break;
  case 8:
    urlqz.value = "/kjts";
    break;
  default:
    urlqz.value = "";
    break;
}

// 选择期数
let qsvalue = ref("");
let qsoptions = reactive([]);
let activeName = ref("");
activeName.value=router.currentRoute.value.query.acn || "jieshao"
// 类型
let contype = store.state.contype;
// 全部期数
let allqishuList = reactive([]);
// 最新的文章列表
let newwzlist = reactive([]);

// 获取全部期数
const getqsall = () => {
  get("/api/NewsPaper/GetAllQishu", {
    type: contype.filter((e) => {
      return e.name === "期刊";
    })[0].value,
    id: props.lmjsdata.Id,
  }).then((res) => {
    // console.log(res.data);
    if (res.data.length === 0) {
      return false;
    }
    // 保存全部期数
    allqishuList.push(...res.data);
    // 渲染期数下拉框 筛选出年份 通过年份生成数组
    let tempval = ""; //临时年份
    let yearsz = []; //年份数组
    allqishuList.forEach((e) => {
      //筛选出数组中年份
      if (tempval == "") {
        tempval = e.year;
        yearsz.push(e.year);
      } else {
        if (tempval != e.year) {
          tempval = e.year;
          yearsz.push(e.year);
        } else {
          return true;
        }
      }
    });
    qsoptions.length = 0; //重置select

    yearsz.forEach((e, i) => {
      //通过年份生成数组
      qsoptions.push({
        value: e,
        label: `${e}年`,
        children: [],
      });
      let childrenval = [];
      allqishuList.forEach((ele) => {
        if (e == ele.year) {
          // 存在小期数添加，不存在为""不添加
          if (ele.smallqs != "") {
            childrenval.push({
              value: ele.Id,
              label: `第${ele.qs}-${ele.smallqs}期`,
            });
          } else {
            childrenval.push({
              value: ele.Id,
              label: `第${ele.qs}期`,
            });
          }
        }
      });
      qsoptions[i].children = childrenval;
    });
  });
};

// 获取最新文章
const getnewwz = () => {
  get("/api/NewsPaper/GetBsQmart", {
    type: contype.filter((e) => {
      return e.name === "期刊";
    })[0].value,
    id: props.lmjsdata.Id,
    top: 10,
  }).then((res) => {
    if (res.data.length === 0) {
      return false;
    }
    newwzlist.push(...res.data);
  });
};
setTimeout(() => {
  getqsall();
  getnewwz();
}, 100);

// 选择期数
const handleChange = (value) => {
  router.push({
    path: urlqz.value + "/index",
    query: {
      navid: router.currentRoute.value.query.dflid, //大分类id
      id: value[1], //当前期数id
      bzid: props.lmjsdata.Id, //报纸id  用于获取全部期数
    },
  });
};

// 跳转期刊
const tiaozhuanqikan = () => {
  // 存在最新一期跳转
  if (allqishuList[0]) {
    router.push({
      path: urlqz.value + "/index",
      query: {
        navid: router.currentRoute.value.query.dflid, //大分类id
        id: allqishuList[0].Id, //最新一期id
        bzid: props.lmjsdata.Id, //报纸id  用于获取全部期数
      },
    });
  }
};

// 跳转文章
const tiaozhuanwz = (wzid) => {
  router.push({
    path: "/jyyj/wzxq", //文章详情公用页面
    query: {
      wzid: wzid, //文章id
    },
  });
};
</script>

<style scoped>
::v-deep .el-tabs__header {
  margin: 0;
}
.baozhijieshao-list:after {
  content: "";
  display: table;
  clear: both;
}
.baozhijieshao-list-fm {
  float: left;
  width: 300px;
  height: 450px;
  box-sizing: border-box;
  border: 1px solid #ccc;
  margin: 5px 0 0 0;
  cursor: pointer;
}
.baozhijieshao-list-xq {
  width: 900px;
  height: 400px;
  float: left;
  box-sizing: border-box;
  padding-left: 30px;
}
.baozhijieshao-list-xq-js {
  margin: 15px 0 0 0;
}
.baozhijieshao-list-xq-js:after {
  content: "";
  display: table;
  clear: both;
}
.baozhijieshao-list-xq-js-list {
  line-height: 24px;
  float: left;
  font-size: 14px;
  margin-bottom: 10px;
}
.baozhijieshao-list-xq-js-list-tsys {
  width: 100%;
  height: 200px;
}
.baozhijieshao-list-xq-js-list-50 {
  width: 50%;
}
.baozhijieshao-list-xq-js-list-title {
  float: left;
  width: 130px;
  height: 24px;
  line-height: 24px;
  font-weight: bold;
}
.baozhijieshao-list-xq-js-list-con {
  width: calc(100% - 130px);
  float: left;
  height: 100%;
  line-height: 24px;
}
.baozhijieshao-list-xq-js-list-con-tsys {
  overflow-y: scroll;
}
.baozhijieshao-cg-qs {
  width: 100%;
  height: 50px;
  font-size: 14px;
}
.baozhijieshao-cg-qs-title {
  width: 80px;
  height: 50px;
  line-height: 50px;
  float: left;
  font-weight: bold;
}
.baozhijieshao-cg-qs-select {
  width: 200px;
  height: 50px;
  float: left;
  display: flex;
  align-items: center;
}
.baozhijieshao-cg-list {
  width: 100%;
  height: 24px;
}
.baozhijieshao-cg-list-null{
  height: 24px;
  color:#999;
}
.baozhijieshao-cg-list:hover {
  background: #fafafa;
  color: #409eff;
}
.baozhijieshao-cg-ul {
  font-size: 14px;
}
.baozhijieshao-cg-list-name {
  width: 80%;
  height: 24px;
  float: left;
  line-height: 24px;
  cursor: pointer;
  text-overflow: ellipsis; /* ellipsis:显示省略符号来代表被修剪的文本  string:使用给定的字符串来代表被修剪的文本*/
  white-space: nowrap; /* nowrap:规定段落中的文本不进行换行   */
  overflow: hidden; /*超出部分隐藏*/
}
.baozhijieshao-cg-list-writer {
  width: 20%;
  float: left;
  height: 24px;
  line-height: 24px;
  text-align: right;
  text-overflow: ellipsis; /* ellipsis:显示省略符号来代表被修剪的文本  string:使用给定的字符串来代表被修剪的文本*/
  white-space: nowrap; /* nowrap:规定段落中的文本不进行换行   */
  overflow: hidden; /*超出部分隐藏*/
}
.baozhijieshao-cg-ul-title {
  width: 100%;
  height: 36px;
  background: #f8f8f8;
  line-height: 36px;
  font-weight: bold;
}
.baozhijieshao-cg-list {
  border-bottom: 1px dashed #ccc;
  padding: 4px 0;
}
.baozhijieshao-list-title {
  width: 100%;
  height: 50px;
  background: #f9f9ff;
  font-size: 20px;
  display: flex;
  align-items: center;
  padding: 0 10px;
  box-sizing: border-box;
  margin: 20px 0 10px 0;
}
.baozhijieshao-list-title > .icon {
  margin-right: 10px;
}
</style>
